export interface MaterialPresentacion {
  idMaterial  : string;
  idUnidad    : string;
  conversionUnidad  : number;
  numeradorUnidad : number;
  status      : string | null;
  unidadMedAlternativa: string | null;
  altura      : string;
  longitud    : string;
  anchura     : string;
  pesoBruto   : number;
  volumen     : string;
  undPeso     : string;
  dispVenta   : number;
  tipoEmpaque : string;
}


//T.14473 CPD Forzado

export class ListMaterialPresentacion {
  presentaciones: MaterialPresentacion[];

  constructor() {
    this.presentaciones = [];
  }
}
